import { generateClient } from 'aws-amplify/api';
import * as mutations from '../graphql/mutations';

const client = generateClient();

export const collectIngredientEditEventOperation = async (
  mealID,
  recipeID,
  ingredientID,
  fullTextBefore,
  fullTextAfter,
  editMethod,
  currentHealthProGroup,
) => {
  const input = {
    mealID,
    recipeID,
    ingredientID,
    fullTextBefore,
    fullTextAfter,
    editMethod,
    groups: currentHealthProGroup && [currentHealthProGroup],
  };
  const response = await client.graphql({
    query: mutations.createIngredientEditEvent,
    variables: { input },
  });
  return response.data.createIngredientEditEvent;
};
